import { BaseEntity } from "yt-ng-framework";

export class RobnaGrupa extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string = null;
    TataID: number = null;
    Items: RobnaGrupa[] = null;
    SourceID: number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.TataID = input.TataID;
        this.SourceID = input.SourceID;
        if (input.Items!=null){
            this.Items=[];
            input.Items.forEach(Item => {
                return this.Items.push(new RobnaGrupa().Deserialize(Item))
            });
        }

        return this;
    }



    Serialize(input:RobnaGrupa){
        input.Items = null;
        return input;
    }

}